import { useQuery } from '@tanstack/react-query';
import { getParentChildren, getChildDetails } from '../../services/parentService';

// Hook to fetch all children for the logged-in parent
export const useParentChildren = () => {
  return useQuery({
    queryKey: ['parent', 'children'],
    queryFn: getParentChildren,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes (legacy property name)
  });
};

// Hook to fetch specific child details
export const useChildDetails = (childId: string | undefined) => {
  return useQuery({
    queryKey: ['parent', 'children', childId],
    queryFn: () => getChildDetails(childId!),
    enabled: !!childId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

// Hook to get the first child (for single child parents)
export const useFirstChild = () => {
  const { data: childrenData } = useParentChildren();
  // Handle both .data and .items properties for compatibility
  const children = Array.isArray(childrenData)
    ? childrenData
    : (childrenData?.items || []);
  const firstChild = children[0];

  return {
    child: firstChild,
    isLoading: !childrenData,
    hasMultipleChildren: children.length > 1,
  };
};
